import React from "react";
import { Element } from "react-scroll";
import { v4 as uuid } from "uuid";
import { Example, Method, Properties, Property } from "../../shared/components";
import { SITE_SCROLL_MARGIN } from "../../shared/constants";
import type { Member, Method as MethodType } from "../../types";

const ClassMembers: React.FC<
    Partial<Member> & {
        methods?: MethodType[];
    }
> = ({ name, description, type, properties, examples, methods, defaultvalue }) => {
    const renderedMember = (
        <>
            {!!name && (
                <Property
                    name={name}
                    description={description}
                    type={type}
                    codeBlock={false}
                    defaultvalue={defaultvalue}
                />
            )}
            {!!properties?.length && <Properties properties={properties} />}
            {!!examples?.length && <Example example={examples[0]} />}
        </>
    );

    return (
        <>
            {renderedMember && (
                <Element id={name} name={name as string} style={{ scrollMarginTop: SITE_SCROLL_MARGIN }}>
                    {renderedMember}
                </Element>
            )}
            {methods?.map((method) => (
                <Method key={uuid()} {...method} />
            ))}
        </>
    );
};
export { ClassMembers };
